import { Peeky, RootUrlParam } from "./peeky";
import $ from 'jquery';
import { PeekyActivator } from "./peeky.activator";

type InteractorOptions = {
	scrollTo?: number | boolean,
	reload?: boolean,
	ajax?: any,
	$dom?: JQuery,
	popupRemote?: boolean,
	preloadOn?: string,
	activateSelector?: string,
	relative?: boolean
}

export class PeekyInteractor {

	private _pk: Peeky;
	private _options: InteractorOptions;
	private _activator: PeekyActivator;

	constructor(pk: Peeky, selector: string, options: InteractorOptions = {}) {
		this._pk = pk;
		this._options = options;

		let that = this;

		// Intercept clicks/submits etc
		pk.root.$dom.on('click submit', selector, function(e) {
			let $this = $(this);
			let tagName = this.tagName.toUpperCase();
			let url: string;
			let opt: InteractorOptions = $.extend(true, {}, options);

			// Check for ctrl / command (open in new window)
			if (e.shiftKey || e.ctrlKey || e.metaKey) {
				return;
			}
			
			// Only listen to "click" and "tap" for non-form 
			if (e.type === 'click' && tagName === 'FORM') {
				return;
			}
			
			// Set default options
			if (!opt.reload) opt.reload = $this.data('reload');
			if (!opt.ajax) opt.ajax = {};
			opt.$dom = $this;
			
			if (tagName.toUpperCase() === 'FORM') {
				url = $this.attr('action') || window.location.href.toString();
				if (!opt.ajax.type) opt.ajax.type = $this.attr('method') || 'POST';
				if (!opt.ajax.form) opt.ajax.form = this;
				if (!opt.reload) opt.reload = true;
			} else {
				url = $this.attr('href') || $this.attr('xlink:href') || $this.data('href') || window.location.href.toString();
			}
			
			// Don't catch mailto: and tel: etc.
			if (!testUrl(url)) {
				if (options.popupRemote) {
					window.open(url, '_blank');
					return false;
				}
				return;
			}
			
			e.preventDefault();
			e.stopPropagation();
			that.goTo(url, opt, $this);
		});


			// Preload on mousedown
		pk.root.$dom.on('mousedown ' + (options.preloadOn || ''), selector, function() {
			let $this = $(this);
			let url: string;
			let param;
			let opt: InteractorOptions = $.extend(true, {}, options);
			if (this.tagName.toUpperCase() === 'FORM') {
				// Don't submit forms on mousedown (user probably clicked to enter text)
				return;
			} else {
				url = $this.attr('href') || $this.attr('xlink:href') || $this.data('href');
			}

			if (!testUrl(url)) {
				return;
			}

			param = pk.urlToParam(url, false, false);
			url = pk.paramToUrl(param);
			
			pk.triggerAction('load', {
				location: url,
				options: opt,
				$dom: $this,
				preLoad: true
			});
		});


		// Remotehover
		pk.root.$dom.on('mouseenter', selector, function() {
			let $this = $(this);
			let url: string;
			if (this.tagName.toUpperCase() === 'FORM') {
				return;
			} else {
				url = $this.attr('href') || $this.attr('xlink:href') || $this.data('href');
			}

			// A URL-string is required
			if (!testUrl(url)) {
				return;
			}
			
			let $matching = pk.root.$dom.find(selector).filter('[href="' + url +'"],[data-href="' + url +'"]').not(this);
			if ($matching.length <= 0) {
				return;
			}

			$matching.addClass('_remotehover');
			setTimeout(function() {
				$(document).one('mouseover', function checkMouseLeave(e) {
					if ($(e.target).parents().addBack().filter($this).length > 0) {
						$(document).one('mouseover', checkMouseLeave);
						return;
					}
					$matching.removeClass('_remotehover');
				});
			}, 0);
		});


		// Add loading class. ALPHA TESTING
		pk.on('prepareSwitch', function(param) {
			let url = param.location.url;
			let $matching = this.root.$dom.find(selector).filter('[href="' + url +'"],[data-href="' + url +'"]');
			$matching.addClass('_pk-loading');
			pk.once('switched', function() {
				$matching.removeClass('_pk-loading');
			});
		});

		// Add _pressed class when pressed
		pk.root.$dom.on('mousedown', selector, function() {
				let $that = $(this);
				$that.addClass('_pressed');
				$('body').one('mouseup', function() {
						$that.removeClass('_pressed');
				});
		});


		let activateSelector;
		if (typeof(options.activateSelector) === 'string') {
			activateSelector = options.activateSelector;
		} else {
			activateSelector = selector;
		}
		this._activator = new PeekyActivator(pk, activateSelector);
	}

	goTo(url: string, localOptions: InteractorOptions, $dom) {
		let param: RootUrlParam;
		let pk = this._pk;
		
		if (!localOptions) {
			localOptions = $.extend(true, {}, this._options);
		} else {
			localOptions = $.extend(true, {}, this._options, localOptions);
		}
		
		// Convert URL
		if (typeof(url) !== 'string' || !(/^https?:\/\//).test(url)) {
			param = this._pk.urlToParam(url, localOptions.relative || false, false);
			url = this._pk.paramToUrl(param);
		}
		
		// Scroll to correct element
		if (localOptions.scrollTo) {
			pk.once('prePrepareSwitch', function(param) {
				let top;
				let scrollTop = $(document).scrollTop();
				function listen(param, element) {
					let offset = element.$dom.offset();
					if (typeof(top) === 'undefined' || top > offset.top) {
						top = offset.top;
					}
				};
				// Look for top element
				pk.on('prepareSwitchState', listen);
				pk.once('postPrepareSwitch', function() {
					pk.off('prepareSwitchState', listen);
					if (typeof(top) !== 'undefined' && scrollTop > top) {
						//$.scrollTo(Math.min(top, $(document).height() - $(window).height()));
					}
				});
			});
		}

		// Replace current state, to set scrollTop / scrollLeft in browser history
		if (window.history.replaceState) {
			window.history.replaceState({
				scrollLeft: $(window).scrollLeft(),
				scrollTop: $(window).scrollTop()
			}, '', window.location.href);
		}

		pk.triggerAction('goTo', {
			location: url,
			options: localOptions,
			$dom: $dom
		});
	}



	
	

}


function matchExternalUrl(url: string) {
	// Check if we have matching protocol (if one is given)
	var hasProtocolRegex = /^[a-zA-Z0-9]+:\/\//;
	var matchProtoHostRegex = new RegExp('^' + window.location.protocol + '//' + window.location.hostname);
	// No protocol given, this is relative
	if (!hasProtocolRegex.test(url)) {
		return false;
	}
	// Different protocol or hostname
	if (!matchProtoHostRegex.test(url)) {
		return true;
	}
	return false;
}


function testUrl(url) {
	// A URL-string is required
	if (typeof(url) !== 'string') return false;
	// Don't handle remote URLS
	if (matchExternalUrl(url)) {
		return false;
	}
	// Don't catch mailto: and tel: etc.
	if ((/^[a-zA-Z0-9]+:[^\/]/).test(url)) return false;
	// Don't catch files
	if ((/^[^?#]+\.[^\/]+$/).test(url)) return false;
	return true;
};





